const defaultState = {
  user: {},
  error: null,
  fetching: false,
  fetched: false
};

const forgotPasswordReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'FORGOT_PASSWORD_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'FORGOT_PASSWORD_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, user: action.payload
      };
    }
    case 'FORGOT_PASSWORD_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default forgotPasswordReducer;


// WEBPACK FOOTER //
// ./src/reducers/forgotPassword.js